import { SelectItem } from '~/components/molecules/FormSelect';

export const contactFormSubject = ['sale', 'rent', 'management'] as const;

export const contactFormSubjectOptions: SelectItem[] = [
  { value: 'sale', label: 'Vente' },
  { value: 'rent', label: 'Location' },
  { value: 'management', label: 'Gestion' },
] as const;

export type ContactFormSubject = (typeof contactFormSubject)[number];
